import {
  SETLISTDATA,
  SETCOUNTRYLINKRESTRICTIONFLAG,
  SETTITLEDATA,
  SETPHONEMESSAGEDATA,
  SETSMSMESSAGEDATA,
  SETEMAILMESSAGEDATA,
  SETCONTACTDATA,
  SETDELAYDATA,
  SETNOTIFYDATA,
  SETDISTANCEFLAGDATA,
  SETDISTANCEDATA,
  SETWORKERTYPESDATA,
  SETLANGUAGEDATA,
  SETENGLISHPOSITIVERESPONSEDATA,
  SETENGLISHNEGATIVERESPONSEDATA,
  SETSPANISHPOSITIVERESPONSEDATA,
  SETSPANISHNEGATIVERESPONSEDATA,
  SETSCHEDULEDATA,
  SETCIDATA,
  SETLISTINPUTDATA,
  SETLISTINPUTTYPE,
  HOMEPAGECREATE,
  HOMEPAGECREATEERROR,
  FETCH2,
  SELECTIONS,
} from './actionType'

// initialState shows what we are going to change
const initialState = {
  // empty text field
  selections: {},
  inputCountryLinkRestrictionFlag: false,
  inputListData: {},
  inputTitleData: '',
  inputPhoneMessageData: '',
  inputSMSMessageData: '',
  inputEmailMessageData: '',
  inputContactData: null,
  inputDelayData: true,
  inputNotifyData: true,
  inputDistanceFlagData: true,
  inputDistanceData: 0,
  inputWorkerTypesData: {
    str: true,
    office: true,
    rgd: true,
    dc: true,
    test: true,
    shipt: true,
  },
  inputLanguageData: true,
  inputEnglishPositiveResponseData: '',
  inputEnglishNegativeResponseData: '',
  inputSpanishPositiveResponseData: '',
  inputSpanishNegativeResponseData: '',
  inputScheduleData: new Date(),
  inputCIData: null,
  inputListInputData: false,
  inputListInputType: null,
  // empty data field
  data: null,
  errorData: null,
  // API call
  fetching2: false,

  // validData: false,
  // titleFromChild: true,
  // phoneMessageFromChild: true,
  // smsMessageFromChild: true,
  // emailMessageFromChild: true,
  // validMessage: false,
  // dialogOpen: false,
  // submitResponse: '',
  // englishPositiveResponseFromChild: true,
  // englishNegativeResponseFromChild: true,
  // spanishPositiveResponseFromChild: true,
  // spanishNegativeResponseFromChild: true,
  // validContactData: true,
  // scheduleDataFormatted: new Date().getMonth() + 1 + '/' + new Date().getDate() + '/' + new Date().getFullYear() + ' ' + new Date().getHours() + ':' + new Date().getMinutes(),
}

// Checks the type of the action and returns the appropriate state
export default function homepageCreateReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH2:
      // Boolean describing if the data is being gathered
      return Object.assign({}, state, {
        fetching2: action.fetching,
      })
    case SELECTIONS:
      return Object.assign({}, state, {
        selections: action.data,
      })
    case SETCOUNTRYLINKRESTRICTIONFLAG:
      return Object.assign({}, state, {
        inputCountryLinkRestrictionFlag: action.data,
      })
    case SETLISTDATA:
      // First 2 params copy over empty data, third param overrides
      return Object.assign({}, state, {
        inputListData: action.data,
      })
    case SETTITLEDATA:
      // First 2 params copy over empty data, third param overrides
      return Object.assign({}, state, {
        inputTitleData: action.data,
      })
    case SETPHONEMESSAGEDATA:
      // First 2 params copy over empty data, third param overrides
      return Object.assign({}, state, {
        inputPhoneMessageData: action.data,
      })
    case SETSMSMESSAGEDATA:
      // First 2 params copy over empty data, third param overrides
      return Object.assign({}, state, {
        inputSMSMessageData: action.data,
      })
    case SETEMAILMESSAGEDATA:
      // First 2 params copy over empty data, third param overrides
      return Object.assign({}, state, {
        inputEmailMessageData: action.data,
      })
    case SETCONTACTDATA:
      // console.log(state.inputContactData)
      if (
        state.inputContactData === null ||
        state.inputContactData === undefined
      ) {
        return Object.assign({}, state, {
          inputContactData: action.data,
        })
      } else {
        // written for immutable updates so that redux doesn't blow up
        return {
          ...state,
          inputContactData: {
            ...state.inputContactData,
            0: {
              ...state.inputContactData[0],
              id: action.data[0].id,
              text: action.data[0].text,
              checked: action.data[0].checked,
            },
            1: {
              ...state.inputContactData[1],
              id: action.data[1].id,
              text: action.data[1].text,
              checked: action.data[1].checked,
            },
            2: {
              ...state.inputContactData[2],
              id: action.data[2].id,
              text: action.data[2].text,
              checked: action.data[2].checked,
            },
          },
        }
      }
    case SETDELAYDATA:
      return Object.assign({}, state, {
        inputDelayData: action.data,
      })
    case SETNOTIFYDATA:
      return Object.assign({}, state, {
        inputNotifyData: action.data,
      })
    case SETDISTANCEFLAGDATA:
      return Object.assign({}, state, {
        inputDistanceFlagData: action.data,
      })
    case SETDISTANCEDATA:
      return Object.assign({}, state, {
        inputDistanceData: action.data,
      })
    case SETWORKERTYPESDATA:
      return Object.assign({}, state, {
        inputWorkerTypesData: action.data,
      })
    case SETLANGUAGEDATA:
      return Object.assign({}, state, {
        inputLanguageData: action.data,
      })
    case SETENGLISHPOSITIVERESPONSEDATA:
      return Object.assign({}, state, {
        inputEnglishPositiveResponseData: action.data,
      })
    case SETENGLISHNEGATIVERESPONSEDATA:
      return Object.assign({}, state, {
        inputEnglishNegativeResponseData: action.data,
      })
    case SETSPANISHPOSITIVERESPONSEDATA:
      return Object.assign({}, state, {
        inputSpanishPositiveResponseData: action.data,
      })
    case SETSPANISHNEGATIVERESPONSEDATA:
      return Object.assign({}, state, {
        inputSpanishNegativeResponseData: action.data,
      })
    case SETSCHEDULEDATA:
      return Object.assign({}, state, {
        inputScheduleData: action.data,
      })
    case SETCIDATA:
      return Object.assign({}, state, {
        inputCIData: action.data,
      })
    case SETLISTINPUTDATA:
      return Object.assign({}, state, {
        inputListInputData: action.data,
      })
    case SETLISTINPUTTYPE:
      return Object.assign({}, state, {
        inputListInputType: action.data,
      })
    case HOMEPAGECREATE:
      return Object.assign({}, state, {
        selections: {},
        inputCountryLinkRestrictionFlag: false,
        inputListData: {},
        inputTitleData: '',
        inputPhoneMessageData: '',
        inputSMSMessageData: '',
        inputEmailMessageData: '',
        inputContactData: null,
        inputDelayData: true,
        inputNotifyData: true,
        inputDistanceFlagData: true,
        inputDistanceData: 0,
        inputLanguageData: true,
        inputEnglishPositiveResponseData: '',
        inputEnglishNegativeResponseData: '',
        inputSpanishPositiveResponseData: '',
        inputSpanishNegativeResponseData: '',
        inputScheduleData: new Date(),
        inputCIData: null,
        inputListInputData: false,
        inputListInputType: null,
        data: action.data,
        errorData: null,
        fetching2: false,
      })
    case HOMEPAGECREATEERROR:
      return Object.assign({}, state, {
        selections: {},
        inputCountryLinkRestrictionFlag: false,
        inputListData: {},
        inputTitleData: '',
        inputPhoneMessageData: '',
        inputSMSMessageData: '',
        inputEmailMessageData: '',
        inputContactData: null,
        inputDelayData: true,
        inputNotifyData: true,
        inputDistanceFlagData: true,
        inputDistanceData: 0,
        inputLanguageData: true,
        inputEnglishPositiveResponseData: '',
        inputEnglishNegativeResponseData: '',
        inputSpanishPositiveResponseData: '',
        inputSpanishNegativeResponseData: '',
        inputScheduleData: new Date(),
        inputCIData: null,
        inputListInputData: false,
        inputListInputType: null,
        data: null,
        errorData: action.errorData,
        fetching2: false,
      })
    default:
      // returns state as is without changes
      return state
  }
}
